import React from 'react';

import { Button } from '../../components';
import css from './BalancePage.css';

export const ErrorBlock = ({ paymentError, navigateFromErrorPage }) => {
    return (
        <>
            <p className={css.error}>
                {paymentError
                    ? 'Zahlung fehlgeschlagen. Bitte versuche es später erneut.'
                    : 'Die Historie deiner Credits ist momentan nicht verfügbar.'}
            </p>
            <Button type="button" onClick={() => navigateFromErrorPage()}>
                Zurück
            </Button>
        </>
    );
};
